import React from "react";
import { ApprvCard } from "../../interface/interface";
import { formatDate } from "../../lib/lib";

type Props = {
  data: ApprvCard;
  OpenFile: (
    e: string | undefined,
    apply_id: string,
    prjt_id: string,
    rcrt_id: string
  ) => void;
  NavPortfolio: (sub: string, content: string, link: string) => void;
};

/** 인증서 관리 게시물 */
const CertificationDetailCard = ({
  data: {
    login_id,
    usr_email,
    login_nm,
    apply_sts_at,
    apply_self_brif_1,
    apply_self_brif_2,
    usr_link,
    apply_id,
    prjt_id,
    rcrt_id,
  },
  OpenFile,
  NavPortfolio,
}: Props) => {
  return (
    <div className="certification-detail-card">
      <div className="left-info">
        <div className="id">{login_id}</div>
        <div className="email">{usr_email}</div>
        <div className="nickname">{login_nm}</div>
        <div className="time">{formatDate(apply_sts_at, "-")}</div>
      </div>
      <div className="right-btns">
        <button
          className="port-btn"
          onClick={() => {
            NavPortfolio(apply_self_brif_1, apply_self_brif_2, usr_link);
          }}
        >
          포트폴리오 보기
        </button>
        {/* ${isCert ? "fix-cert" : ""} */}
        <button
          className={`cert-view-btn `}
          onClick={() => {
            OpenFile("", apply_id, prjt_id, rcrt_id);
          }}
        >
          인증서
          {/* {isCert ? "수정" : "업로드"} */}
        </button>
      </div>
    </div>
  );
};

export default CertificationDetailCard;
